import { PERCENTAGE, FIXED } from '@core/reducers/cart/constants';
import getCartPlusInfo from '@core/reducers/cart/selectors/getCartPlusInfo';
import { NOT_SET } from '@utils/tracking/constants';

export const getDeliveryAmount = (shippingAmount, plusSettings) => {
  const discountAmount = plusSettings?.amount;
  const calculationType = plusSettings?.calculationType;
  let finalPrice = shippingAmount;
  if (shippingAmount > 0) {
    if (calculationType === PERCENTAGE) {
      const totalDiscount = shippingAmount * (discountAmount / 100);
      finalPrice = shippingAmount - totalDiscount;
    }
    if (calculationType === FIXED) {
      finalPrice = shippingAmount - discountAmount;
    }
  }
  return finalPrice > 0 ? finalPrice : 0;
};

export const getTrackingPlusValue = state => {
  const plusSettings = getCartPlusInfo(state);

  if (!plusSettings) return 'false 0%';

  const { calculationType, amount } = plusSettings;

  if (calculationType === PERCENTAGE) return `true ${amount}%`;
  if (calculationType === FIXED) return `true ${FIXED.toLowerCase()} ${amount}`;

  return NOT_SET;
};
